import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function Solution() {
  return <section className="w-full bg-plum-50 py-16 md:py-24" data-id="element-199" data-mp="1emovlp7jcjdr">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-200" data-mp="10s4oa5ctpkc1">
        <SectionHeading eyebrow="La solución" title={<>
              El Puente <span className="italic text-gold-700" data-id="element-202" data-mp="qv9ozk8q7fwp">del Adiós</span>
            </>} intro={<p data-id="element-203" data-mp="vucwdbc6hy7u">
              Un megapack organizado en 4 tomos complementarios + 3 recursos adicionales para
              acompañar diferentes momentos del duelo infantil y adolescente.
            </p>} data-id="element-201" data-mp="15s0sa4litbrl" />

        <div className="mx-auto mt-14 grid max-w-4xl overflow-hidden rounded-xl bg-white shadow-card md:grid-cols-2" data-id="element-204" data-mp="mu7q54iq15v9">
          <div className="border-b border-plum-100 bg-cream p-8 text-center md:border-b-0 md:border-r md:p-10" data-id="element-205" data-mp="2c94bwno87azq">
            <XCircleIcon className="mx-auto h-8 w-8 text-plum-300" aria-hidden="true" data-id="element-206" data-mp="2h5cwigl6zwea" />
            <p className="mt-5 text-[0.7rem] font-bold uppercase tracking-[0.18em] text-muted" data-id="element-207" data-mp="6yxge3xkpw4g">
              Lo que no es
            </p>
            <p className="mt-4 font-display text-xl font-bold leading-snug text-ink md:text-2xl" data-id="element-208" data-mp="gqa8mwnaaob0">
              No es un único PDF con actividades genéricas.
            </p>
          </div>

          <div className="p-8 text-center md:p-10" data-id="element-209" data-mp="3k7aa3emok0ps">
            <CheckCircle2Icon className="mx-auto h-8 w-8 text-teal-500" aria-hidden="true" data-id="element-210" data-mp="3k7shn7esm1d0" />
            <p className="mt-5 text-[0.7rem] font-bold uppercase tracking-[0.18em] text-gold-700" data-id="element-211" data-mp="3g70627ig7kdk">
              Lo que sí es
            </p>
            <p className="mt-4 font-display text-xl font-bold leading-snug text-plum-700 md:text-2xl" data-id="element-212" data-mp="3p6d7qe0bz4nq">
              Una biblioteca práctica de recursos para saber qué herramienta utilizar según la edad y
              el momento.
            </p>
          </div>
        </div>
      </div>
    </section>;
}